import React from 'react';

export function Badge({ status, trueLabel = 'Active', falseLabel = 'Inactive' }) {
  const active = status === 1 || status === true;
  return (
    <span style={{
      display: 'inline-block',
      padding: '2px 10px',
      borderRadius: 20,
      fontSize: 12,
      fontWeight: 600,
      background: active ? '#D1FAE5' : '#FEE2E2',
      color: active ? '#065F46' : '#991B1B',
    }}>
      {active ? trueLabel : falseLabel}
    </span>
  );
}

export function BoolBadge({ val }) {
  const isTrue = val === true || val === 1 || val === '1' || val === 'true';
  return (
    <span style={{
      display: 'inline-block',
      padding: '1px 8px',
      borderRadius: 12,
      fontSize: 12,
      fontWeight: 600,
      background: isTrue ? '#EDE8FA' : '#F3F4F6',
      color: isTrue ? '#6C3FC5' : '#6B7280',
    }}>
      {isTrue ? 'Yes' : 'No'}
    </span>
  );
}

export function CategoryBadge({ label }) {
  if (!label) return '—';
  return (
    <span style={{
      background: '#EDE8FA',
      color: '#4B2A9A',
      borderRadius: 12,
      padding: '2px 10px',
      fontSize: 12,
      fontWeight: 600,
    }}>
      {label}
    </span>
  );
}
